import React from "react";
import DirectLink from "./items/direct-link";
import GroupLinks from "./items/group-links";
import MegaMenu from "./items/mega-menu";
import clsx from "clsx/lite";

const DesktopHeaderData = ({ data, setShowOverlay, embedHeader }) => {
	if (!data?.links?.length) return null;

	const components = {
		groupLinks: GroupLinks,
		link: DirectLink,
		megaMenu: MegaMenu,
	};

	return (
		<div className="flex my-auto w-full">
			<div
				className="desktop-header-data xl:grid xl:justify-normal grid-flow-col auto-cols-auto">
				{data.links?.map((link, index) => {
					const LinkComponent = components[link._type];
					if (!LinkComponent) return null;

					return (
						<LinkComponent
							className={clsx(
								"text-[15px] xxl:text-lg font-semibold",
								index === 0 && "border-b border-black",
								index === 0 && embedHeader && "border-b border-white"
							)}
							setShowOverlay={setShowOverlay}
							data={link}
							key={link?._key}
							embedHeader={embedHeader}
						/>
					);
				})}
			</div>
		</div>
	);
};

export default DesktopHeaderData;